'use client';

import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import Icon from '@publishing/components/ui/Icon';
import { ActionCloseType1 } from '@publishing/components/ui/SvgSprite';
import { useBodyScrollLock } from '@publishing/hooks/useBodyScrollLock';
import styles from './AgreementModal.module.scss';

export interface AgreementModalProps {
  title: string;
  children: ReactNode;
  onClose: () => void;
}

export default function AgreementModal({ title, children, onClose }: AgreementModalProps) {
  useBodyScrollLock(true);

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    queueMicrotask(() => setMounted(true));
  }, []);

  const modal = (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.modal}>
        <button onClick={onClose} className={styles.close_button} aria-label="닫기">
          <Icon name={ActionCloseType1} size={20} />
        </button>
        <div className={styles.scroll_area}>
          <div className={styles.head}>
            <h2 className={styles.title}>{title}</h2>
          </div>
          <div className={styles.body}>{children}</div>
        </div>
      </div>
    </div>
  );

  if (!mounted) return null;

  return createPortal(modal, document.body);
}
